import { createRouter, createWebHistory } from "vue-router";
import AppRoot from "@app/app-root.vue";
import { appRoutes } from "@/app/router/app-routes";
import { publicRoutes } from "@/app/router/public-routes";
const ProcessEndScreenView = () => import("@views/public/process-end-screen-view.vue");

const routes = [
    
    {
        children: [
            ...publicRoutes,
            ...appRoutes
        ],

        component: AppRoot,
        path: "/",
        name: "home",
        redirect: "/public/sign-in", // this is the default public view
    },
    {
        component: ProcessEndScreenView,
        name: "ProcessEndScreen",
        path: "/process-end",
        props: true,
    },
];
const router = createRouter({
    history: createWebHistory(""),
    routes,
    scrollBehavior(to, from, savedPosition: any) {
        if (savedPosition) {
          return savedPosition;
        }
        if (to.hash) {
          
          return { 
            el: to.hash,
            behavior: 'smooth',
          };
        }
        return { top: 0  };
      }
});

// router.afterEach((to, from) => {
//     if (to.meta.hasLPTag != undefined && to.meta.hasLPTag == false) {
//         if (window.lpTag) {
//             window.lpTag.newPage("https://newpos.takoleasy.si/noLP");
//         }
//     } else {
//         if (window.lpTag) {
//             window.lpTag.newPage("https://newpos.takoleasy.si");
//         }
//     }
// });

export default router;